import generateId from 'uuid/v1'

const browserSessionId = generateId()

export default browserSessionId
